module.exports = __webpack_public_path__ + "img/tab-3.0929fa34.jpg";